import { apiDelete } from 'api/api-delete'
import { apiGet } from 'api/api-get'
import { apiPost } from 'api/api-post'
import { apiPut } from 'api/api-put'
import { urls } from 'api/api-url'
import { BACK_OFFICE } from 'constant'

export const postLoginAdmin = async (data) => {
  return apiPost({
    url: urls.auth.login,
    data: { email: data?.email, password: data?.password, portal: BACK_OFFICE }
  })
}
export const postForgotPassword = (email, platform) => {
  return apiPost({
    url: urls.auth.forgotPassword,
    data: {
      email: email,
      portal: platform
    }
  })
}
export const postResetPassword = (token, password, confirmPassword) => {
  return apiPost({
    url: urls.auth.resetPassword,
    data: {
      token: token,
      password: password,
      password_confirmation: confirmPassword
    }
  })
}
export const postConfirmOtp = (token, code) => {
  return apiPost({
    url: urls.auth.confirmOtp,
    data: {
      token: token,
      code: code
    }
  })
}

export const register = (values) => {


  return apiPost({
    url: urls.auth.register,
    data: values
  })
}

/* export const validateEmail = (email) => {
  return apiPost({
    url: urls.auth.validateEmail,
    data: {
      email: email,
    }
  })
} */

export const confirmEmail = (code, token) => {
  return apiPost({
    url: urls.auth.confirmEmail,
    token: token,
    data: {
      code: code,
    }
  })
}

export const resendEmailConfirmation = (token) => {

  return apiGet({ url: urls.auth.resendEmailConfirmation, token: token })
}

export const registerDetail = (values, token) => {
  return apiPost({
    url: urls.auth.registerDetail,
    data: values,
    token: token
  })
}

export const verifyDiscountCode = (discount_code, token) => {
  return apiPost({
    url: urls.auth.verifyDiscount,
    data: {
      discount_code: discount_code
    },
    token: token
  })
}

export const registerPayment = (values, token) => {
  return apiPost({
    url: urls.auth.registerPayment,
    data: values,
    token: token
  })
}

export const paymentConfirm = (values, token) => {
  return apiPost({
    url: urls.auth.confirmPayment,
    data: values,
    token: token
  })
}

export const directPaymentConfirm = (values, token) => {
  return apiPost({
    url: urls.auth.confirmPaymentDirectly,
    data: values,
    token: token
  })
}

export const directCardConfirm = (values, token) => {
  return apiPost({
    url: urls.auth.cardConfirm,
    data: values,
    token: token
  })
}


export const preparePayment = (token) => {
  return apiPost({
    url: urls.auth.preparePayment,
    token: token
  })
}



export const paymentConfirmDirectly = (values, token) => {
  return apiPost({
    url: urls.auth.confirmPaymentDirectly,
    data: values,
    token: token
  })
}

export const registerPaymentDireclty = (values, token) => {
  return apiPost({
    url: urls.auth.registerPaymentDirectly,
    data: values,
    token: token
  })
}

export const createCompany = (values, token) => {
  return apiPost({
    url: urls.auth.companies,
    data: values,
    token: token
  })
}

export const addPaymentCard = (values, token, id) => {
  return apiPost({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.paymentCards}`,
   // data: values,
    token: token
  })
}

export const onAddCardpaymentConfirm = (values, token, id) => {
  return apiPost({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.paymentCards3dSecure}`,
    data: values,
    token: token
  })
}


export const setDefaultCard = (token, id, cardId) => {
  return apiPut({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.paymentCard}/${cardId}/${urls.subscriptions.setDefault}`,
    token: token
  })
}

export const deleteCard = (token, id, cardId) => {
  return apiDelete({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.paymentCard}/${cardId}`,
    token: token
  })
}

export const onRequestBill = (token, id, subscription_id) => {
  return apiPut({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.orders}/${subscription_id}/${urls.subscriptions.requestBill}`,
    token: token
  })
}

export const onCancelSubscription = (token, id) => {
  return apiPut({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.cancelSubscription}`,
    token: token
  })
}

export const onReactivateSubscription = (token, id) => {
  return apiPut({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.reactivateSubscription}`,
    token: token
  })
}



export const onUpdateSubscription = (token, id, values) => {
  return apiPut({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.updateSubscription}`,
    data: values,
    token: token
  })
}

/* export const validateRegisterCompanyEmail = (token, data) => {
  return apiPost({ url: urls.auth.validateEmail, token: token, data: data })
}

export const validateRegisterCompanyAdminEmail = (data) => {
  return apiPost({ url: urls.auth.validateCompanyEmail, data: data })
} */

export const validateFields = (token, data) => {

  
  return apiPost({ url: urls.auth.validateAllFields, token: token, data: data })
}

export const getNewParamsForSubscription = (token, id,data) => {
  return apiPut({
    url: `${urls.company.companies}/${id}/${urls.subscriptions.newParamsForSubscription}`,
    token: token,
    data:data
  })
}